import axios from "axios";
import Echo from "laravel-echo";
import Pusher from "pusher-js";

window.axios = axios;

window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

window.Pusher = Pusher;

const reverbKey = import.meta.env.VITE_REVERB_APP_KEY;
const broadcastConnection = import.meta.env.VITE_BROADCAST_CONNECTION;

if (broadcastConnection === "reverb" && reverbKey) {
    const forceTLS = window.location.protocol === "https:";
    const port = Number.parseInt(
        window.location.port || (forceTLS ? "443" : "80"),
        10,
    );

    window.Echo = new Echo({
        broadcaster: "reverb",
        key: reverbKey,
        authEndpoint:
            import.meta.env.VITE_BROADCAST_AUTH_ENDPOINT ??
            "/broadcasting/auth",
        wsHost: window.location.hostname,
        wsPort: port,
        wssPort: port,
        forceTLS,
        enabledTransports: ["ws", "wss"],
    });
}
